import {MapOption} from '../AppTypes';
import React from 'react';

interface MapSelectorProps {
    value?: string;
    maps?: MapOption[];
    onSelect: (name: string) => void;
}

export class MapSelector extends React.Component<MapSelectorProps> {
    public render(): JSX.Element {
        if (this.props.maps) {
            return (
                <select
                    id="PlayerLogin-select-map"
                    value={this.props.value}
                    onChange={this.handleChange}
                >
                    {this.renderOptions(this.props.maps)}
                </select>
            );
        } else {
            return <div>Loading...</div>;
        }
    }

    private renderOptions(maps: MapOption[]): JSX.Element[] {
        return maps.map((map, idx) => (
            <option key={idx} value={map.name}>
                {map.name} ({map.playerCount})
            </option>
        ));
    }

    private handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.props.onSelect(event.currentTarget.value);
    };
}



// WEBPACK FOOTER //
// ./src/MapSelector/index.tsx